import { Formik, useFormikContext } from 'formik';
import moment from 'moment';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable, useObservable } from 'react-use-observable';
import { tap } from 'rxjs/operators';
import Modal from 'v2/components/Shared/Modal';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { financialStatementService } from 'v2/services/financialStatement/statement';

import { initialFilter } from './constants';
import Form from './Form';
import SuccessStep from './SuccessStep';
import { FilterSchema } from './validations';

import type { ExportStatement, Props } from './constants';
import type { FormikProps } from 'formik';

function ExportContent({ isOpen, showSuccess, setClose }: Props) {
  const { isValid, isSubmitting, submitForm } = useFormikContext<ExportStatement>();

  return (
    <Modal
      open={isOpen}
      size='sm'
      setClose={setClose}
      textTitle='Exportar'
      textReturnButton='Fechar'
      textProceedButton={showSuccess ? 'Sair' : 'Gerar'}
      handleProceedClick={showSuccess ? setClose : submitForm}
      isProceedButtonDisabled={isSubmitting || !isValid}
      hideReturnButton={showSuccess}
    >
      {showSuccess ? <SuccessStep /> : <Form />}
    </Modal>
  );
}

function ExportModal({ isOpen, setClose }: Props) {
  const [showSuccess, setShowSuccess] = useState(false);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const [submitRequestExport] = useCallbackObservable((userEmail, values, setSubmitting) => {
    const startMoment = typeof values.date[0] === 'string' ? moment(values.date[0], 'DD/MM/YYYY') : values.date[0];
    const endMoment = typeof values.date[1] === 'string' ? moment(values.date[1], 'DD/MM/YYYY') : values.date[1];

    const dataRequest = {
      start_date: startMoment.format('YYYY-MM-DD'),
      end_date: endMoment.format('YYYY-MM-DD'),
      email: values.email || userEmail,
      export_in_future: values.export_in_future,
      export_blocked: values.export_blocked,
    };

    return financialStatementService.requestExport(dataRequest).pipe(
      tap(
        () => {
          toast.success('Sucesso, arquivos de exportação solicitados com êxito!');
          setShowSuccess(true);
          setSubmitting(false);
        },
        (err) => {
          toast.error(err);
          setSubmitting(false);
        }
      )
    );
  }, []);

  const onSubmit = (values: ExportStatement, { setSubmitting }: FormikProps<ExportStatement>) => {
    submitRequestExport(user?.email, values, setSubmitting);
  };

  return (
    <Formik initialValues={initialFilter} validationSchema={FilterSchema} onSubmit={onSubmit}>
      <ExportContent isOpen={isOpen} setClose={setClose} showSuccess={showSuccess} />
    </Formik>
  );
}

export default ExportModal;
